<template>
  <div class="right">
    <ul class="rightUl">
      <li>
        <p class="hello">Hello!</p>
        <img class="ma" src="~@/assets/img/kefuma.png">
        <p class="hui">微信扫一扫<br>享一对一咨询</p>
      </li>
      <li>
        <div class="anniu">24小时客服热线</div>
      </li>
      <li>
        <div>客服咨询</div>
        <p class="dian">400-805-0105</p>
      </li>
      <!-- <li>
        <div class="iconfont icon-htmal5icon31"></div>
        <p>热线电话</p>
        <div class="hover phone">010-80225300</div>
      </li>
      <li @click="jump()" v-if="show == 1 && type == 'gyl'">
        <div class="iconfont icon-zuojiantou"></div>
        <p>返回赛兰</p>
      </li>
      <li class="top" @click="$emit('top')">
        <div class="iconfont icon-shang"></div>
        <p>TOP</p>
      </li> -->
    </ul>
  </div>
</template>
<script>
export default {
  name: 'right',
  props: {
    type: String,
    show: Number
  },
  methods: {
    jump () {
      location.href = 'index.html'
    }
  }
}
</script>
<style lang="stylus" scoped>
.right
  position fixed
  right .36rem
  bottom 30%
  width 1.8rem
  box-shadow 0px 0px 29px 0px rgba(9, 9, 9, 0.23)
  z-index 9999
  border-radius .12rem
  .rightUl
    border-radius .12rem
  li
    width 100%
    text-align center
    padding .12rem
    background #fff
    border-top 1px solid #F4F4F4
    position relative
    border-top 2px solid #D5A14E
    align-items center
    display flex
    justify-content center
    flex-flow row wrap
    div
      font-size .12rem
      color #666
    .anniu
      padding 0 .12rem
      border-radius .12rem
      color #fff
      font-size .12rem
      line-height .24rem
      background linear-gradient(90deg, #000000 0%, #D5A14E 0%, #E49F30 100%)
    .hello
      font-size .37rem
      color #D22016
      font-weight bold
      margin-top .13rem
    .dian
      font-size .2rem
      color #D22016
      font-weight bold
    .ma
      width .94rem
      margin-top .23rem
    .hui
      font-size .12rem
      color #666
      margin-top .15rem
      line-height 0.16rem
  li:first-child
    border 0px
    border-top-left-radius .12rem
    border-top-right-radius .12rem
  li:last-child
    border-bottom-left-radius .12rem
    border-bottom-right-radius .12rem
</style>



// WEBPACK FOOTER //
// src/components/right.vue